var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal modal--banner modal-banner"},[(_vm.isLoading)?_c('div',{staticClass:"modal__loading"},[_c('loading-spinner')],1):_vm._e(),_c('div',{staticClass:"modal-banner__form"},[_c('form-banner',{attrs:{"banner":_vm.banner}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }